export async function waitForTilled(maxWait = 8000) {
  return new Promise((resolve, reject) => {
    const start = Date.now();
    const check = () => {
      if (window.Tilled) return resolve(window.Tilled);
      if (Date.now() - start > maxWait)
        return reject(new Error("Tilled.js did not load within timeout."));
      setTimeout(check, 300);
    };
    check();
  });
}
